import { ReferentialKey } from 'api/referential';
import { SearchFilterEnum } from 'api/actor';
import { ComponentKey } from 'enums/componentKey';
import { InputsConfig } from 'types/form/inputsConfig';
import { addressInputsConfig } from 'features/new-actor/form/inputs-config/addressInputsConfig';
import { CompagnieFormFieldNames } from './CompagnieFormFieldNames';
import { CompagnieFormValues } from './CompagnieFormValues';

import { gerantInputsConfig } from 'back-office/shared/components/gerant/gerantFields';
/** Champs rendus via InputFactory — les comptes bancaires ont leur propre
 * composant (liste dynamique) et ne passent pas par ce config. */
export type CompagnieInputFieldName = Exclude<
  keyof CompagnieFormValues,
  'bankAccounts'
>;

export const compagnieInputsConfig: InputsConfig<CompagnieInputFieldName> = {
  ...gerantInputsConfig,
  ...addressInputsConfig,
  [CompagnieFormFieldNames.CompanyName]: {
    componentKey: ComponentKey.InputText,
    name: CompagnieFormFieldNames.CompanyName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.COMPAGNIE.LABELS.COMPANY_NAME',
    placeholder: 'ACTOR_FORM.COMPAGNIE.PLACEHOLDERS.COMPANY_NAME'
  },
  [CompagnieFormFieldNames.Phone]: {
    componentKey: ComponentKey.InputText,
    name: CompagnieFormFieldNames.Phone,
    type: 'tel',
    required: false,
    label: 'ACTOR_FORM.BROKER.LABELS.PHONE',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.PHONE'
  },
  [CompagnieFormFieldNames.RegistrationNumber]: {
    componentKey: ComponentKey.InputText,
    name: CompagnieFormFieldNames.RegistrationNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.REGISTRATION_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.REGISTRATION_NUMBER'
  },
  [CompagnieFormFieldNames.Capital]: {
    componentKey: ComponentKey.InputText,
    name: CompagnieFormFieldNames.Capital,
    type: 'number',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.CAPITAL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.CAPITAL',
    min: 0
  },
  [CompagnieFormFieldNames.RcsCity]: {
    componentKey: ComponentKey.InputText,
    name: CompagnieFormFieldNames.RcsCity,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.RCS_CITY',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCS_CITY'
  },
  [CompagnieFormFieldNames.RcsNumber]: {
    componentKey: ComponentKey.InputText,
    name: CompagnieFormFieldNames.RcsNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.RCS_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCS_NUMBER'
  },
  [CompagnieFormFieldNames.FirstName]: {
    componentKey: ComponentKey.InputText,
    name: CompagnieFormFieldNames.FirstName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.FIRST_NAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.FIRST_NAME'
  },
  [CompagnieFormFieldNames.LastName]: {
    componentKey: ComponentKey.InputText,
    name: CompagnieFormFieldNames.LastName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.LAST_NAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.LAST_NAME'
  },
  [CompagnieFormFieldNames.Email]: {
    componentKey: ComponentKey.InputText,
    name: CompagnieFormFieldNames.Email,
    type: 'email',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.EMAIL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.EMAIL',
    existenceCheck: {
      enabled: true,
      type: 'email',
      searchFilter: SearchFilterEnum.Email,
      debounceMs: 500,
      errorMessage: 'Cette adresse email existe déjà'
    }
  },
  [CompagnieFormFieldNames.Username]: {
    componentKey: ComponentKey.InputText,
    name: CompagnieFormFieldNames.Username,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.USERNAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.USERNAME'
  },
  [CompagnieFormFieldNames.Password]: {
    componentKey: ComponentKey.InputText,
    name: CompagnieFormFieldNames.Password,
    type: 'password',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.PASSWORD',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.PASSWORD'
  },
  [CompagnieFormFieldNames.PlateformeIds]: {
    componentKey: ComponentKey.ReferentialTagInput,
    name: CompagnieFormFieldNames.PlateformeIds,
    referentialKey: ReferentialKey.Plateforme,
    label: 'COMMON.LABELS.ORGANIZATIONS',
    placeholder: 'COMMON.PLACEHOLDERS.ORGANIZATIONS',
    required: false
  }
};
